import script from "./FormRadioGroupField.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormRadioGroupField.vue?vue&type=script&lang=ts&setup=true"

import "./FormRadioGroupField.vue?vue&type=style&index=0&id=1968202a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1968202a"]])

export default __exports__